import React from 'react';
import { Loader2, Navigation, User } from 'lucide-react';
import { NearbyProject, formatDistanceKm } from '../services/nearbyProjects';

// Umfeld-Check-Anzeige: welche Projekte liegen in der Naehe und wer betreut sie.
// Urspruenglich inline im ProjectSetupWizard; herausgeloest, damit die
// Auftragsannahme (AcceptQuoteDialog) dieselbe Darstellung zeigt.

interface Props {
    checking: boolean;
    projects: NearbyProject[];
    /** Adresse liess sich nicht verorten -> "Entfernung unbekannt". */
    geocodeFailed?: boolean;
    className?: string;
}

export const NearbyProjectsPanel: React.FC<Props> = ({ checking, projects, geocodeFailed, className }) => {
    if (!checking && projects.length === 0 && !geocodeFailed) return null;

    return (
        <div className={`animate-slide-down bg-indigo-50 border border-indigo-100 rounded-xl p-3 ${className || ''}`}>
            <div className="flex justify-between items-center mb-2">
                <div className="flex items-center gap-2 text-xs font-bold text-indigo-800 uppercase">
                    <Navigation className="w-3 h-3 text-indigo-600" /> Umfeld-Check
                </div>
                {checking && <Loader2 className="w-3 h-3 animate-spin text-indigo-500" />}
            </div>
            {projects.length > 0 ? (
                <div className="space-y-1.5">
                    {projects.map((p) => (
                        <div key={p.id} className="flex items-center justify-between bg-white p-2 rounded-lg border border-indigo-100 shadow-sm">
                            <div className="min-w-0 flex-1">
                                <div className="flex items-center gap-2">
                                    <span className="font-bold text-slate-800 text-xs truncate">{p.name}</span>
                                    <span className="text-[10px] bg-indigo-100 text-indigo-700 px-1.5 rounded-full font-bold whitespace-nowrap">
                                        {formatDistanceKm(p.distanceKm)}
                                    </span>
                                </div>
                                <div className="flex items-center gap-2 mt-0.5">
                                    <User className="w-3 h-3 text-slate-400" />
                                    <span className="text-[11px] text-slate-500">{p.coordinator || 'Unbekannt'}</span>
                                </div>
                            </div>
                            <div className="text-[10px] text-slate-400 whitespace-nowrap">
                                {p.address || 'Keine Adresse'}
                            </div>
                        </div>
                    ))}
                </div>
            ) : geocodeFailed ? (
                <p className="text-[11px] text-indigo-400 italic">
                    Adresse konnte nicht verortet werden — Entfernung unbekannt. Die Auswahl ist trotzdem möglich.
                </p>
            ) : (
                !checking && <p className="text-[11px] text-indigo-400 italic">Keine Projekte in unmittelbarer Nähe.</p>
            )}
        </div>
    );
};
